import Entity from '../views/PrevisaoDemanda/PrevisaoDemanda'

let routes = {
    path: '/previsao-demanda',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/previsao-demanda',
            name: 'previsao-demanda',
            component: Entity,
            meta: {
                pageTitle: 'Previsão de Demanda',
                breadcrumb: [
                    {
                        text: 'Relatórios',
                        active: false,
                    },
                    {
                        text: 'Previsão de Demanda',
                        active: true,
                        to: '/previsao-demanda',
                    },
                ],
            },
        },
    ]
};

export default routes
